import { useQuery } from 'react-query';
import { LogDeAcessoResponse } from 'types/response/groupPay/LogDeAcessoResponse';
import { Cond21CloudResponse } from 'types/response/Cond21CloudResponse';
import { http } from 'shared/util/http';
import { api } from 'constants/RotasAPI';

const buscarLogsDeAcesso = async (email: string): Promise<LogDeAcessoResponse> => {
    const emailEncoded = encodeURIComponent(email);
    const response = await http.get<Cond21CloudResponse<LogDeAcessoResponse>>(
        `${api.groupPay.getEmailAccessLogs}/${emailEncoded}`
    );

    return response.data.payload || [];
};

export const useGetLogsDeAcesso = (email: string) => {
    return useQuery<LogDeAcessoResponse, Error>(
        ['logsDeAcessoEmail', email],
        () => buscarLogsDeAcesso(email),
        {
            enabled: !!email
        }
    );
};